import React from 'react';
import styles from './UserGuides.module.css';

interface GuideItem {
  id: number;
  title: string;
  description: string;
  icon: string;
  action?: () => void;
}

const defaultGuides: GuideItem[] = [
  {
    id: 1,
    title: "Deployment & Installation Guide",
    description: "Short description on the card content area. Although you can have multiple lines of text here. The text should wrap within the content section of the card.",
    icon: "icon-settings",
  },
  {
    id: 2,
    title: "Administration Guide",
    description: "Short description on the card content area. Although you can have multiple lines of text here. The text should wrap within the content section of the card.",
    icon: "icon-profile",
  },
  {
    id: 3,
    title: "Technical Solution Guide",
    description: "Short description on the card content area. Although you can have multiple lines of text here. The text should wrap within the content section of the card.",
    icon: "icon-info",
  },
  {
    id: 4,
    title: "Troubleshooting Guide",
    description: "Short description on the card content area. Although you can have multiple lines of text here. The text should wrap within the content section of the card.",
    icon: "icon-fault",
  },
  {
    id: 5,
    title: "Dimensioning Guide",
    description: "Short description on the card content area. Although you can have multiple lines of text here. The text should wrap within the content section of the card.",
    icon: "icon-edit",
  },
  {
    id: 6,
    title: "Hardening Guide",
    description: "Short description on the card content area. Although you can have multiple lines of text here. The text should wrap within the content section of the card.",
    icon: "icon-shield",
  }
];

const UserGuides: React.FC = () => {
  return (
    <div>
      <div className={styles.guidesGrid}>
        {defaultGuides.map((guide) => (
          <div key={guide.id} className={styles.guideCard}>
            <div className={styles.titleArea}>
              <div className={styles.title}>
              <i className={`icon ${guide.icon}`} />
              <p>{guide.title}</p>
              </div>
              <i className='icon icon-arrow-right' />
            </div>
            <div className={styles.guideContent}>
              <p className={styles.guideDescription}>{guide.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserGuides;